import { useState, useEffect, useCallback } from 'react';

const slides = [
    {
        id: 1,
        title: 'Micro Enterprises',
        quote: 'Micro Enterprises – The First Step Towards Economic Dignity',
        description: 'Empowering grassroots entrepreneurs and local artisans worldwide.',
        imageUrl: 'https://i.pinimg.com/736x/a3/36/23/a33623cfd1c8fd3456135335d85061fc.jpg',
        ctaText: 'Support Micro Entrepreneurs',
        ctaLink: '#',
        unsplashCredit: 'Photo by Annie Spratt'
    },
    {
        id: 2,
        title: 'Small & Medium  Enterprises',
        quote: 'Small & Medium  Enterprises – Building Better Lives and Stronger Communities',
        description: 'Creating sustainable livelihoods through local production and workshops.',
        imageUrl: 'https://i.pinimg.com/1200x/c1/fc/17/c1fc178711da0aceb6f3537d11e9f94a.jpg',
        ctaText: 'Strengthen Local Economies',
        ctaLink: '#',
        unsplashCredit: 'Photo by ThisisEngineering'
    },
    //   {
    //     id: 3,
    //     title: 'Medium Enterprises',
    //     quote: 'Medium Enterprises – The Backbone of National Economies',
    //     description: 'Driving exports, innovation, and employment across industries.',
    //     imageUrl: 'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=1950&q=80',
    //     ctaText: 'Scale Your Business',
    //     ctaLink: '#',
    //     unsplashCredit: 'Photo by Campaign Creators'
    //   },
    // {
    //     id: 4,
    //     title: 'Innovation',
    //     quote: 'Innovation – The Engine of Sustainable MSME Growth',
    //     description: 'Harnessing technology, digital tools, and clean energy for progress.',
    //     imageUrl: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1950&q=80',
    //     ctaText: 'Explore Innovation Programs',
    //     ctaLink: '#',
    //     unsplashCredit: 'Photo by Christina @ wocintechchat.com'
    // },
    {
        id: 5,
        title: 'WASME Solutions',
        quote: 'WASME – Connecting MSMEs to Markets, Finance, Technology and the World',
        description: 'Global partnerships for policy, finance, and international cooperation.',
        imageUrl: 'https://i.pinimg.com/736x/c5/8a/4e/c58a4e9317f92ffdc12a1abd9c7b67a9.jpg',
        ctaText: 'Join Our Network',
        ctaLink: '#',
        unsplashCredit: 'Photo by Austin Distel'
    }
];

const HeroSlider = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false);

    const goToSlide = useCallback((index) => {
        setIsTransitioning(true);
        setCurrentSlide(index);
        setTimeout(() => setIsTransitioning(false), 700);
    }, []);

    const nextSlide = useCallback(() => {
        goToSlide((currentSlide + 1) % slides.length);
    }, [currentSlide, goToSlide]);

    const prevSlide = useCallback(() => {
        goToSlide((currentSlide - 1 + slides.length) % slides.length);
    }, [currentSlide, goToSlide]);

    useEffect(() => {
        const interval = setInterval(nextSlide, 7000);
        return () => clearInterval(interval);
    }, [nextSlide]);

    return (
        <div className="relative h-screen overflow-hidden bg-gray-900">
            {/* Slides Container */}
            <div className="relative h-full">
                {slides.map((slide, index) => (
                    <div
                        key={slide.id}
                        className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${index === currentSlide ? 'opacity-100 z-10' : 'opacity-0 z-0'
                            }`}
                    >
                        <div>{/* Background Image with Gradient Overlay */}

                            <img
                                src={slide.imageUrl}
                                alt=""
                                className="absolute inset-0 w-full h-full object-cover object-center transform transition-transform duration-[10000ms] ease-linear"
                                style={{
                                    transform: index === currentSlide ? 'scale(1.05)' : 'scale(1)'
                                }}
                            />

                            <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 via-gray-900/60 to-transparent" />
                            <div className="absolute inset-0 bg-gradient-to-t from-gray-900/90 via-gray-900/40 to-transparent" />
                        </div>

                        {/* Content */}
                        <div className="relative z-20 h-full flex items-center">
                            <div className="container mx-auto px-6 lg:px-12 max-w-7xl">
                                <div className="max-w-2xl">
                                    {/* Slide Indicator */}
                                    <div className="flex items-center space-x-2 mb-8">
                                        <div className="h-1 w-12 bg-blue-500" />
                                        <span className="text-blue-400 font-semibold tracking-wider uppercase text-sm">
                                            {slide.title}
                                        </span>
                                    </div>

                                    {/* Quote */}
                                    <h1 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight">
                                        {slide.quote}
                                    </h1>

                                    {/* Description */}
                                    <p className="text-xl md:text-2xl text-gray-200 mb-10 max-w-xl">
                                        {slide.description}
                                    </p>

                                    {/* CTA Button */}
                                    <a
                                        href={slide.ctaLink}
                                        className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-[#2b93d0] to-[#1a7bb8] hover:from-[#1a7bb8] hover:to-[#2b93d0] text-white font-semibold text-lg rounded-lg transition-all duration-300 transform hover:translate-y-[-2px] hover:shadow-2xl shadow-lg"
                                    >
                                        {slide.ctaText}
                                        <svg
                                            className="w-5 h-5 ml-3"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M17 8l4 4m0 0l-4 4m4-4H3"
                                            />
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Image Credit */}
                       
                    </div>
                ))}
            </div>

            {/* Navigation Buttons */}
            <button
                onClick={prevSlide}
                className="absolute left-6 top-1/2 transform -translate-y-1/2 z-30 p-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full transition-all duration-300"
                aria-label="Previous slide"
            >
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
            </button>
            <button
                onClick={nextSlide}
                className="absolute right-6 top-1/2 transform -translate-y-1/2 z-30 p-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full transition-all duration-300"
                aria-label="Next slide"
            >
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
            </button>

            {/* Slide Indicators */}
            <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-30 flex space-x-3">
                {slides.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => goToSlide(index)}
                        className={`w-3 h-3 rounded-full transition-all duration-300 ${index === currentSlide
                                ? 'bg-white w-12'
                                : 'bg-white/50 hover:bg-white/75'
                            }`}
                        aria-label={`Go to slide ${index + 1}`}
                    />
                ))}
            </div>

            {/* Progress Bar */}
            <div className="absolute bottom-0 left-0 right-0 h-1 z-30 bg-gray-700">
                <div
                    className="h-full bg-blue-500 transition-all duration-1000 ease-linear"
                    style={{
                        width: isTransitioning ? '0%' : '100%',
                        transition: isTransitioning ? 'none' : 'width 7000ms linear'
                    }}
                />
            </div>

            {/* WASME Logo/Identity */}

        </div>
    );
};

export default HeroSlider;